export default __webpack_public_path__ + "static/media/1 (2).95365f37.jpg";